import { TablePagination } from 'components/molecules';
import { PaperCardTemplate } from 'components/templates/PaperCardTemplate';
import {
  RepresentativePartnersProvider,
  useRepresentativePartners,
} from 'context/RepresentativePartnersContext';

import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import { ConvertedPartnersRow } from './ConvertedPartnersRow';

export const Component: React.FC = () => {
  const {
    loading,
    docs,
    page,
    totalPages,
    handleNextPage,
    handlePreviousPage,
  } = useRepresentativePartners();

  return (
    <PaperCardTemplate loading={loading}>
      <Typography fontWeight={700} fontSize={18} mb={4}>
        PARCEIROS CONVERTIDOS
      </Typography>

      <Table size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="row">
              <Typography fontWeight={500} fontSize={14}>
                Data
              </Typography>
            </TableCell>

            <TableCell>
              <Typography fontWeight={500} fontSize={14}>
                Nome Fantasia
              </Typography>
            </TableCell>

            <TableCell>
              <Typography fontWeight={500} fontSize={14} color="#4B4B4B">
                CNPJ
              </Typography>
            </TableCell>

            <TableCell>
              <Typography fontWeight={500} fontSize={14} color="#4B4B4B">
                Status
              </Typography>
            </TableCell>

            <TableCell align="center" width={50}>
              Ação
            </TableCell>
          </TableRow>
        </TableHead>

        {docs?.length < 1 && (
          <Typography component="caption">
            <Box textAlign="center">
              Não possui nenhum parceiro convertido ainda.
            </Box>
          </Typography>
        )}

        <TableBody>
          {docs?.map((partner) => (
            <ConvertedPartnersRow
              key={partner._id}
              convertedPartner={partner}
            />
          ))}
        </TableBody>
      </Table>

      {totalPages > 1 && (
        <TablePagination
          currentPage={page}
          maxPage={totalPages}
          onPreviousClick={handlePreviousPage}
          onNextClick={handleNextPage}
        />
      )}
    </PaperCardTemplate>
  );
};

export const ConvertedPartners: React.FC = () => (
  <RepresentativePartnersProvider>
    <Component />
  </RepresentativePartnersProvider>
);
